import {
    REQUEST_DEVICE_LOG_OPEN_MODAL,
    REQUEST_DEVICE_LOG_CLOSE_MODAL,
    REQUEST_DEVICE_LOG_REQUEST,
    REQUEST_DEVICE_LOG_RESULT,
} from 'Redux/actionTypes';

export const requestDeviceLogOpenModal = () => ({
    type: REQUEST_DEVICE_LOG_OPEN_MODAL
})

export const requestDeviceLogCloseModal = () => ({
    type: REQUEST_DEVICE_LOG_CLOSE_MODAL
})

export const requestDeviceLogRequest = (data) => ({
    type: REQUEST_DEVICE_LOG_REQUEST,
    payload: data
})

export const requestDeviceLogResult = (result) => ({
    type: REQUEST_DEVICE_LOG_RESULT,
    payload: result
})